import { useState } from "react";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const faqCreateEndpoint = ApiEndpoints.faq.faqCreate;

export default function AddFaq() {
  const [faqData, setFaqData] = useState({
    url: "",
    status: "0",
    faqs: [{ question: "", answer: "" }],
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFaqData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFaqChange = (index, field, value) => {
    const updatedFaqs = [...faqData.faqs];
    updatedFaqs[index][field] = value;
    setFaqData((prevData) => ({
      ...prevData,
      faqs: updatedFaqs,
    }));
  };

  const addFaq = () => {
    setFaqData((prevData) => ({
      ...prevData,
      faqs: [...prevData.faqs, { question: "", answer: "" }],
    }));
  };

  const removeFaq = (index) => {
    if (faqData.faqs.length === 1) {
      toast.error("At least one question and answer is required.");
      return;
    }

    setFaqData((prevData) => ({
      ...prevData,
      faqs: prevData.faqs.filter((item, faqIndex) => faqIndex !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!faqData.url.trim()) {
      toast.error("URL is mandatory.");
      return;
    }

    const hasEmptyFaq = faqData.faqs.some((faq) => !faq.question.trim() || !faq.answer.trim());
    if (hasEmptyFaq) {
      toast.error("Question and answer fields are mandatory.");
      return;
    }

    try {
      const response = await ApiRequest("POST", faqCreateEndpoint, faqData);
      if (response.error === false) {
        toast.success(response.message);
        navigate("/faq");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error creating FAQ:", error);
    }
  };

  const pagename = {
    name: "FAQ Management",
    user: "Admin",
    innerpage: "FAQ Management / Add FAQ"
  };

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="faqAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-8">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>URL<small>*</small></label>
                  </div>
                  <input type="text" name="url" value={faqData.url} onChange={handleChange} className="form-control" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Status</label>
                  </div>
                  <select name="status" value={faqData.status} onChange={handleChange} className="form-control">
                    <option value="0">Enable</option>
                    <option value="1">Disable</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {faqData.faqs.map((faq, index) => (
            <div className="add-content-wrap" key={index}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="add-page-sections">Question {index + 1}</div>
                </div>

                <div className="col-lg-12">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Question<small>*</small></label>
                    </div>
                    <input type="text" value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} className="form-control" />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Answer<small>*</small></label>
                    </div>
                    <textarea value={faq.answer} onChange={(e) => handleFaqChange(index, "answer", e.target.value)} className="form-control" rows="4" style={{ height: "auto" }}></textarea>
                  </div>
                </div>

                <div className="col-lg-12">
                  <button type="button" className="default-btn" onClick={() => removeFaq(index)}>Remove<span></span></button>
                </div>
              </div>
            </div>
          ))}

          <div className="add-content-wrap">
            <button type="button" className="default-btn" onClick={addFaq}>Add More<span></span></button>
            <button type="submit" className="default-btn" style={{ marginLeft: "10px" }}>Submit<span></span></button>
          </div>
        </form>
      </div>
    </>
  );
}
